/*
 * 文件EN: APIAuthorize.js,
 * 文件CN: api授权,
 * 创建时间: Wednesday, 17th June 2020 9:56:15 am,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */

import * as Models from '@/api/T9/APIAuthorize'

export default {
  namespaced: true,
  actions: {
    // 获取列表
    async getList(ctx, payload) {
      return await Models.getListData(payload).then(res => {
        return (res && res.status === 200 && res.data) && Promise.resolve(res.data) || Promise.reject(`data: ${null}`)
      })
    },
    // 获取详情
    async getDetails(ctx, payload) {
      return await Models.fetchDetails(payload).then(res => {
        return (res && res.status === 200 && res.data) && Promise.resolve(res.data) || Promise.reject(`data: ${null}`)
      })
    },
    // 提交
    // 新增
    async create(ctx, payload) {
      return await Models.create(payload).then(res => {
        return (res.status === 200) ? Promise.resolve(res) : Promise.reject(res)
      })
    },
    // 调用方修改信息
    async update(ctx, payload) {
      return await Models.update(payload).then(res => {
        return (res.status === 200) ? Promise.resolve(res) : Promise.reject(res)
      })
    },
  }
}
